/* eslint-disable max-len */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */

/**
 * Sort Icon
 *
 * @file SortIcon.jsx
 * @author Gladson Samuel S
 * @since 0.0.1
 */

import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import PropType from 'prop-types';

const SortIcon = ({ className }) => (
  <SvgIcon className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M14.222 10.2222C14.7129 10.2222 15.1109 10.6201 15.1109 11.1111V13.3333C15.1109 14.5606 14.116 15.5555 12.8887 15.5555H3.11089C1.88359 15.5555 0.888672 14.5606 0.888672 13.3333V11.1111C0.888672 10.6201 1.28664 10.2222 1.77756 10.2222C2.26848 10.2222 2.66645 10.6201 2.66645 11.1111V13.3333C2.66645 13.5787 2.86543 13.7777 3.11089 13.7777H12.8887C13.1341 13.7777 13.3331 13.5787 13.3331 13.3333V11.1111C13.3331 10.6201 13.7311 10.2222 14.222 10.2222ZM7.99978 0.444397C8.4907 0.444397 8.88867 0.842366 8.88867 1.33329V8.17907L11.0196 6.02666C11.3455 5.69746 11.8739 5.69746 12.1998 6.02666C12.5257 6.35587 12.5257 6.88962 12.1998 7.21882L8.59091 10.8642C8.26499 11.1934 7.73658 11.1934 7.41067 10.8642L3.79977 7.21679C3.47386 6.88759 3.47386 6.35384 3.79977 6.02463C4.12569 5.69543 4.6541 5.69543 4.98001 6.02463L7.11089 8.17704V1.33329C7.11089 0.842366 7.50886 0.444397 7.99978 0.444397Z" fill="#0D004D" />
  </SvgIcon>
);

SortIcon.propTypes = {
  className: PropType.string.isRequired
};

export default SortIcon;

